module.exports = __webpack_public_path__ + "static/media/stat547u_lecture07.9f356a56.pdf";